module.exports = __webpack_public_path__ + "static/media/FPX.aa0cd193.png";